package com.xtream.data_kmp

import com.xtream.data_kmp.dto.Account
import com.xtream.data_kmp.dto.BaseStream
import com.xtream.data_kmp.dto.LiveStream
import com.xtream.data_kmp.dto.ServerInfo
import com.xtream.data_kmp.dto.VodStream


class XtreamUtils {


    companion object {
        fun buildStreamUrl(
            user: Account?,
            baseStream: BaseStream?,
            format: String? = ".ts",
            streamType: String? = null,
            forceHttps: Boolean = false

        ): String? {
           // Log.d("XtreamUtils", "buildStreamUrl: $baseStream")
            if(user==null||baseStream==null)
                return null

            if(!baseStream.directSource.isNullOrEmpty()) {
                return baseStream.directSource
            }
            else {


                val serverUrl: String = buildBaseUrl(user.serverInfo, forceHttps= forceHttps)
                val username: String = user.userInfo.username
                val password: String = user.userInfo.password
                val streamId: String = baseStream.streamId.toString()/*when(baseStream){
             is SeriesStream->{
                 baseStream.streamId
             }
              else-> baseStream.streamId.toString()
          }*/

                val strType: String = streamType?: when (baseStream) {
                    is LiveStream -> {
                        AllConst.LIVE_STREAMS
                    }
                    is VodStream ->{
                        AllConst.VODS_STREAMS

                    }
                    else -> {
                        AllConst.SERIES_STREAMS

                    }
                }


                return serverUrl +
                        "/$strType/$username/$password/$streamId$format"

            }


        }

        private  fun buildPort(
            serverProtocol: String?,
            httpPort: String? = "",
            httpsPort: String? = "",
            rtmpPort: String? = ""
        ): String {

            val protocol = serverProtocol?.trim()?.lowercase()
            val port= when (protocol) {

                "http" -> {
                    httpPort ?: ""
                }

                "https" -> {
                    httpsPort ?: ""
                }

                "rtmp" -> {
                    rtmpPort ?: ""
                }

                else -> ""
            }
            return if (port.contains(":",true)) port else ":$port"
        }

        fun buildBaseUrl(serverInfo: ServerInfo?,
                         forceHttps: Boolean = false
        ): String {
            return if(serverInfo==null)""
            else
                "${if(forceHttps) "https" else serverInfo.serverProtocol}://${serverInfo.url}${buildPort(if(forceHttps) "https" else serverInfo.serverProtocol,
                    httpPort =serverInfo.port , httpsPort =serverInfo.httpsPort , rtmpPort =serverInfo.rtmpPort )}"

        }


    }
}